import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingBlockquote: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 0H0v16h4zm12 0H6v4h10zM6 6h10v4H6zm10 6H6v4h10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingBlockquote
